export function scrollOverAmount(e: unknown, amount = 0.8): boolean {
    if (typeof e !== 'object' || e === null || !('target' in e)) {
        return false;
    }

    const target = (e as Event).target;

    if (!target || typeof target !== 'object' || !('scrollingElement' in target)) {
        return false;
    }

    const doc = target as Document;
    const scrollingElement = doc.scrollingElement;

    if (!scrollingElement) {
        return false;
    }

    const { scrollTop, clientHeight } = scrollingElement;
    const { innerHeight } = window;

    return Math.round(scrollTop) + innerHeight > clientHeight * amount;
}

export function scrollOverAmountElement(e: unknown, amount = 0.8): boolean {
    if (typeof e !== 'object' || e === null || !('target' in e)) {
        return false;
    }

    const target = (e as Event).target;

    if (!target || !(target instanceof HTMLElement)) {
        return false;
    }

    const { scrollTop, offsetHeight, scrollHeight } = target;

    return Math.round(scrollTop) + offsetHeight > scrollHeight * amount;
}
